<template>
    <div class="container">
        <div class="title">{{$l('archives/name')}}</div>
        
        <div class="options">
            <div v-if="getSettingsAddons.noise == '1'" :class="getClass('noise')" @click="clicked('global')" class="option" >{{$l('archives/popOver/Global')}}</div>
            <div  v-if="getSettingsAddons.noise == '1'" :class="getClass('noise')" @click="clicked('noise')" class="option" >{{$l('archives/popOver/Noise')}}</div>
            <div  v-if="getSettingsAddons.noise == '1'" @click="clicked('audio')" class="option" >{{$l('archives/popOver/Audio')}}</div>
            <div  v-if="getSettingsAddons.video == '1'" :class="getClass('video')" @click="clicked('video')" class="option" >{{$l('archives/popOver/Video')}}</div>
            <div  v-if="getSettingsAddons.weather == '1'" :class="getClass('weather')" @click="clicked('weather')" class="option" >{{$l('archives/popOver/Weather')}}</div>
            <div   v-if="getSettingsAddons.adio == '1'" :class="getClass('adio')" @click="clicked('adio')" class="option" >{{$l('archives/popOver/Adio')}}</div>
            <div :class="getClass('compressed')" @click="clicked('compressed')" class="option" >{{$l('archives/popOver/Compressed')}}</div>
        </div>
    </div>
</template>

<style scoped>
    .container{
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        
    }
    .title{
        border-bottom:1px solid #e9edef ;
        padding-bottom: 10px;
        font-size: 15px;
        margin-bottom: 5px;
        text-align: center;
        font-weight: 600;
    }
    .option{
        text-align: center;
        padding: 5px;
        cursor: default;
    }
    .option:hover{
        background-color: rgba(0,0,0,0.05);
    }
    .option.disabled{
        color:#e9edef;
    }
    .option.disabled:hover{
        background-color: transparent;
    }
     .disabled-button{
        cursor: not-allowed !important;
        color:#e9edef;
    }
</style>

<script>
import { mapGetters } from 'vuex'
export default {
    computed:{
        ...mapGetters([
            'getSettingsAddons'
        ])
    },
    methods:{
        clicked: function(type){
            var type_show = type;
            if (type == 'global') type_show = 'noise'
            if(this.getSettingsAddons[type_show]=='0') return
            this.$router.push('/archives/'+type);
        },
         getClass:function(menu){
            if(this.getSettingsAddons[menu]=='0') return 'disabled-button';
            return '';
        },
    }
}
</script>



// WEBPACK FOOTER //
// ArchivePopover.vue?9457b7d4